import { STATUSES } from 'constants/user';
import { STEPS_LABELS } from 'constants/constants';
import { ROLES } from '../../permission';

const LIMIT = 25;

export const LABELS = {
  SERVICE: 'Service',
  JOB: 'Job',
  CURRENT_COMPANIES: 'Current companies',
  TECHNOLOGIES: 'Technologies',
  SPECIALITY: 'Specialty',
  LOCATIONS: 'Locations',
  EXPERIENCE_LEVEL: 'Experience level',
  COMPANIES: 'Company',
  COURSES_ATTENDED: 'Courses attended',
  CANDIDATES_STATUSES: 'Candidates status',
  JOB_STEP: 'Job step',
  RESPONSIBLE_RECRUITER: 'Responsible Recruiter',
  INTERACTED_BY: 'Interacted by',
  SOURCE: 'Source',
  COUNTRY: 'Country',
  CITY: 'City',
  LAST_INTERACTION: 'Last interaction period',
  ADDED_BY: 'Added by',
  ADDED_DURING: 'Added in period',
  INTERVIEWED_BY: 'Interviewed by',
  INTERVIEWED_DURING: 'Interviewed during',
  INTERVIEW_DATE: 'Interviewed in period',
  CANDIDATE_STATUS: 'Candidate status',
  TAGS: 'Tags',
  TEAM_LEAD: 'Team Lead',
};

export const CANDIDATE_STATUSES = [
  { value: STATUSES.ACTIVE, label: STATUSES.ACTIVE },
  { value: STATUSES.PASSIVE, label: STATUSES.PASSIVE },
  { value: STATUSES.HIRED, label: STATUSES.HIRED },
  { value: STATUSES.BLACKLISTED, label: STATUSES.BLACKLISTED },
  { value: STATUSES.FIRED, label: STATUSES.FIRED },
];

export const EXPERIENCE_LEVEL = [
  { value: 'No Level', label: 'No Level' },
  { value: 'Entry', label: 'Entry' },
  { value: 'Junior', label: 'Junior' },
  { value: 'Middle', label: 'Middle' },
  { value: 'Senior', label: 'Senior' },
  { value: 'Lead', label: 'Lead' },
  { value: 'Custom', label: 'Custom' },
];

export const STEPS_OPTIONS = Object.values(STEPS_LABELS).map(s => ({ value: s, label: s }));

export const OPTIONS_REQUEST_CONFIG = {
  service: (search, limit = LIMIT) => ({ url: `services/`, body: { limit, has_job: true, search } }),
  team_lead: (search, limit = LIMIT) => ({ url: `users/`, body: { limit, role: ROLES.TEAM_LEAD, search } }),
  jobs: (search, limit = LIMIT) => ({ url: `jobs/`, body: { limit, search }, version: 'v2' }),
  speciality: (search, limit = LIMIT) => ({ url: `candidates/specialities/`, body: { limit, search } }),
  tags: (search, limit = LIMIT) => ({ url: `candidates/tags/`, body: { limit, search } }),
  companies: (search, limit = LIMIT) => ({ url: `candidates/companies/`, body: { limit, search } }),
  country: (search, limit = LIMIT) => ({ url: `candidates/countries/`, body: { limit, search } }),
  responsible_recruiters: (search, limit = LIMIT) => ({
    url: `candidates/responsible-recruiters/`,
    body: { limit, search },
  }),
  interacted_by: (search, limit = LIMIT) => ({
    url: `users/`,
    body: { limit, role: [ROLES.HR_LEAD, ROLES.RECRUITER_LEAD, ROLES.RECRUITER], search },
  }),
  interviewed_by: (search, limit = LIMIT) => ({
    url: `users/`,
    body: { limit, role: [ROLES.HR_LEAD, ROLES.RECRUITER_LEAD, ROLES.RECRUITER], search },
  }),
  added_by: (search, limit = LIMIT) => ({
    url: `users/`,
    body: { limit, role: [ROLES.HR_LEAD, ROLES.RECRUITER_LEAD, ROLES.RECRUITER], search },
  }),
};
